import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useFlags } from '@atlaskit/flag';
import EditorRemoveIcon from '@atlaskit/icon/glyph/editor/remove';
import ModalDialog from '@atlaskit/modal-dialog';
import { ButtonClickedEvent } from '@atlassian/mpac-analytics';
import { deletePromotionCode } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { ANALYTICS_SUBJECT_ID_DELETE_PROMOTION_CODE } from "../../../../analytics/Events";
import { getFlagForError } from "../../../../utils/FlagUtils";

var DeletePromotionCode = function DeletePromotionCode(props) {
  var _useFlags = useFlags(),
      showFlag = _useFlags.showFlag;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isConfirmationModalOpen = _useState2[0],
      setConfirmationModalOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var handleOpenModal = function handleOpenModal() {
    return setConfirmationModalOpen(true);
  };

  var handleCloseModal = function handleCloseModal() {
    return setConfirmationModalOpen(false);
  };

  var _useAnalyticsEvents = useAnalyticsEvents(),
      createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;

  var handleDeletePromotionCode = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              createAnalyticsEvent({
                eventType: ButtonClickedEvent,
                actionSubjectId: ANALYTICS_SUBJECT_ID_DELETE_PROMOTION_CODE
              }).fire();
              _context.prev = 2;
              _context.next = 5;
              return deletePromotionCode(props.mpacBaseUrl, props.partnerId, props.promotionId, props.promotionCode);

            case 5:
              handleCloseModal();
              props.onDeletePromotionCode(props.promotionCode);
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              showFlag(getFlagForError('delete-promotion-code-flag', 'Deleting the promotion code failed'));
              log.error('PromotionCodes/DeletePromotionCode', "Failed to delete Promotion Code", {
                error: _context.t0
              });

            case 13:
              setIsLoading(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    }));

    return function handleDeletePromotionCode() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    "data-testid": "delete-promotion-code__remove-icon",
    onClick: handleOpenModal
  }, /*#__PURE__*/React.createElement(EditorRemoveIcon, null)), isConfirmationModalOpen && /*#__PURE__*/React.createElement(ModalDialog, {
    actions: [{
      text: 'Cancel',
      appearance: 'subtle',
      onClick: handleCloseModal
    }, {
      text: 'Delete',
      isLoading: isLoading,
      appearance: 'primary',
      onClick: handleDeletePromotionCode
    }],
    onClose: handleCloseModal,
    heading: "Remove Single-use code"
  }, "Are you sure you want to remove ", props.promotionCode, " ?"));
};

export default DeletePromotionCode;